import { Api } from '@/services/Api';

export default {
    getPages(pages = {
        treeId: 0,
        instanceId: 0,
        keyWord: ""
    }) {
        return Api().post(`/Form/GetPages`, pages);
    },
    savePage(body, nodeId) {
        return Api().post(`/Form/SavePage?nodeId=${nodeId}`, body);
    },
    deletePages(pages) {
        return Api().post(`/Form/DeletePage`, pages);
    },
    deleteAllPages(pages) {
        return Api().post(`/Form/DeleteAllPage`, pages);
    },
    postPages(pages) {
        return Api().post(`Form/PostPage`, pages);
    },
}